import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Button, Grid, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";

import DialogForm from "../DialogForm";
import { ConfirmDialog } from "../../../../components";
import StoreApi from "../../../../services/Apis/Store.Api";

import dynamicStyle from "./styles";

const StoreList = (props) => {
  const { data, refetch } = props;

  const classes = dynamicStyle();

  const [openDialog, setOpenDialog] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [storeID, setStoreID] = useState(null);

  const hadnleOpenDialog = () => {
    setOpenDialog(true);
  };

  // Open Delete Dialog ..
  const handleConfirmOpen = (id) => {
    setStoreID(id);
    setConfirmOpen(true);
  };

  const handleOpenUpdateDialog = (id) => {
    setStoreID(id);
    setOpenDialog(true);
  };

  //   Mui Table Columns ..
  const columns = [
    {
      name: "ID",
      label: "ID",
    },
    {
      name: "storeName",
      label: "Store Name",
      options: { filterOptions: { fullWidth: true } },
    },

    // Actions  ...
    {
      name: "actions",
      label: "Actions",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const id = tableMeta.rowData[0];
          return (
            <>
              <IconButton
                onClick={() => {
                  handleConfirmOpen(id);
                }}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  handleOpenUpdateDialog(id);
                }}
              >
                <EditIcon />
              </IconButton>
            </>
          );
        },
      },
    },
  ];

  //   Mui Table Options ..
  const options = {
    search: true,
    download: true,
    print: false,
    viewColumns: true,
    filter: true,
    filterType: "dropdown",
    // responsive,
    selectableRows: "none",

    onTableChange: (action, state) => {
      console.log(action);
      console.dir(state);
    },
  };

  const handleDelete = async () => {
    const response = await StoreApi.deleteStore(storeID);
    if (response.success) {
      toast.success(response.message);
      setConfirmOpen(false);
      refetch();
    } else {
      toast.error("Store not deleted!");
    }
  };

  return (
    <Grid>
      {/* Button Grid */}
      <Grid
        container
        justifyContent="space-between"
        className={classes.buttonGrid}
      >
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={hadnleOpenDialog}
          >
            ADD New Store
          </Button>
        </Grid>
      </Grid>
      {/* Mui Table Gri */}
      <Grid style={{ marginTop: 20 }}>
        <MUIDataTable
          title={"Stores list"}
          data={data}
          columns={columns}
          options={options}
        />
      </Grid>

      {/* Create and Update Tag  Dialog*/}
      <DialogForm
        open={openDialog}
        setOpen={setOpenDialog}
        refetchTags={refetch}
        storeID={storeID}
        setStoreID={setStoreID}
      />
      <Grid>
        {/* Delete Confirm Dialog  */}
        <ConfirmDialog
          title="Delete Store ?"
          dialogContext="Are you sure to delete Store"
          open={confirmOpen}
          setOpen={setConfirmOpen}
          onConfirm={handleDelete}
        />
      </Grid>
    </Grid>
  );
};

export default StoreList;
